import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface SubscribeMutationObject {
  mutation: {
    addNewSubscriber: {
      __args: {
        input: {
          email: string
        }
      }
      message: boolean
      status: boolean
    }
  }
}

export const subscribeMutationObject: SubscribeMutationObject = {
  mutation: {
    addNewSubscriber: {
      __args: {
        input: {
          email: ''
        }
      },
      message: true,
      status: true
    }
  }
}

interface SubscribeMutationInput {
  email: string
}

export type SubscribeMutation = (input: SubscribeMutationInput) => Promise<FetchResult<any>>

export const createSubscribeMutation = ({ getMutations }: ServiceDependencies): SubscribeMutation => async ({ email }) => {
  const mutation = getMutations().subscribeMutation
  mutation.mutation.addNewSubscriber.__args.input.email = email

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
